/**
 * Gemini Function Declaration for Sales Invoice Creation
 * This function allows the AI agent to pre-fill sales invoice forms
 */

export const createSalesInvoiceTool = {
  functionDeclarations: [
    {
      name: 'createSalesInvoice',
      description:
        'Creates and saves a new sales invoice. Call this ONLY after the user has explicitly confirmed the invoice details (company, items, and total).',
      parameters: {
        type: 'OBJECT',
        properties: {
          companyName: {
            type: 'STRING',
            description: 'The name of the company to bill.'
          },
          invoiceDate: {
            type: 'STRING',
            description: 'The date of the invoice in YYYY-MM-DD format. Do not assume or default to today; you must ask the user if it is not provided.'
          },
          items: {
            type: 'ARRAY',
            description: 'List of line items to add to the invoice.',
            items: {
              type: 'OBJECT',
              properties: {
                item: {
                  type: 'STRING',
                  description: 'Item name or description'
                },
                quantity: {
                  type: 'NUMBER',
                  description: 'Quantity of the item'
                },
                unitPrice: {
                  type: 'NUMBER',
                  description: 'Price per unit in USD'
                }
              }
            }
          }
        },
        required: ['companyName', 'invoiceDate', 'items']
      }
    }
  ]
};

export {};